import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';

// Suppress harmless ResizeObserver warning
// This occurs when charts/components resize rapidly and is safe to ignore
const resizeObserverErrFilter = (err) => {
  if (!err) return; // Skip if error is null/undefined

  if (
    err.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    err.message === 'ResizeObserver loop limit exceeded'
  ) {
    return; // Ignore this error
  }
  // Log all other errors
  console.error(err);
};

window.addEventListener('error', (e) => {
  resizeObserverErrFilter(e.error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        {/* React Query Devtools (only in development) */}
        {process.env.NODE_ENV === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        )}
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
